import { Alert } from '../../../../../../mads';
import { useI18n } from '../../../../../../shared/I18n';

export function JobExpiredHeader() {
    const { gettext } = useI18n();

    const alertTitle = gettext('This job has expired on Indeed', [
        'message to explain that a job has expired',
    ]);

    const alertBody = gettext(
        'Reasons could include: the employer is not accepting applications, is not actively hiring, or is reviewing applications',
        ['explanation of why a job is expired'],
    );

    return <Alert status="critical" title={alertTitle} explainerText={alertBody} />;
}
